import React, { FC, useContext, useEffect } from "react";
import { ErrorMessage, useFormikContext } from "formik";
import NumberFormat, { InputAttributes } from "react-number-format";
import { FormControl, TextField } from "@mui/material";
import { AvgInterestResponse } from "../@types/responses";
import { AvgInterestRequest } from "../@types/requests";
import { Values } from "../@types/common";
import { BREAKPOINTS } from "../constants/common";
import { APIContext } from "../context/context";
import { ReactComponent as Percent } from "../assets/icons/percent.svg";
import { translation as t } from "../utils/translation";
import { useWindowSize } from "../hooks/useWindowWidth";
interface NumberFormatCustomProps {
  onChange: (values: any) => void;
}
const NumberFormatCustom = React.forwardRef<
  NumberFormat<InputAttributes>,
  NumberFormatCustomProps
>(function NumberFormatCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <>
      <NumberFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange(values.value);
        }}
        decimalScale={2}
        isNumericString
      />
      <Percent />
    </>
  );
});
async function fetchNewToAvgInterest(
  period: string,
  scheduleId: string,
  productCode: string,
  interestRateUrl: string
) {
  const params: AvgInterestRequest = {
    productPeriodPairs: [
      {
        period: Number(period),
        scheduleId: Number(scheduleId),
        productCode: Number(productCode),
      },
    ],
  };
  //for Development
  // const response = await fetch(interestRateUrl);
  // const names = (await response.json()) as AvgInterestResponse;
  // return names.avgInterests[0].avgInterest;
  // for Production
  const response = await fetch(interestRateUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(params),
  });
  const resJson = (await response.json()) as AvgInterestResponse;
  return resJson.avgInterests[0].avgInterest;
  // End for Production
}
interface InterstRateProps {
  name: string;
  index: number;
  onChange(): void;
}
const InterstRate: FC<InterstRateProps> = ({ name, index, onChange }) => {
  const {
    values: { tracks },
    setFieldValue,
    setFieldTouched,
  } = useFormikContext<Values>();
  const API_AND_URLS = useContext(APIContext);
  const windowWidth = useWindowSize();
  const { EXTRA_SMALL, EXTRA_EXTRA_LARGE } = BREAKPOINTS;
  const interestRateUrl =
    API_AND_URLS !== undefined ? API_AND_URLS.API.POST.AVG_INTEREST : ""; // for Production
  useEffect(() => {
    let isCurrent = true;
    if (
      tracks[index].period !== "" &&
      tracks[index].scheduleId !== "" &&
      tracks[index].productCode !== ""
    ) {
      fetchNewToAvgInterest(
        tracks[index].period,
        tracks[index].scheduleId,
        tracks[index].productCode,
        interestRateUrl
      ).then((res) => {
        if (!!isCurrent) {
          if (tracks[index].interestRate == "") {
            setFieldValue(name, res);
          }
        }
      });
    }
    return () => {
      isCurrent = false;
    };
  }, [
    index,
    name,
    setFieldValue,
    tracks[index].period,
    tracks[index].productCode,
    tracks[index].scheduleId,
  ]);
  return (
    <div className={`${windowWidth > EXTRA_EXTRA_LARGE ? "my-0" : "my-3"}`}>
      <FormControl
        variant="standard"
        className={`${windowWidth > EXTRA_SMALL ? "w-[130px]" : "w-[75px]"}`}
      >
        <TextField
          label={t.INTEREST}
          value={tracks[index].interestRate}
          onChange={(value) => {
            setFieldValue(`tracks[${index}].interestRate`, value);
            onChange();
          }}
          name="numberformat"
          id="mui-select-standard-label-interest-rate"
          InputProps={{
            inputComponent: NumberFormatCustom as any,
          }}
          onBlur={() => {
            if (tracks[index].interestRate != "")
              setFieldTouched(`tracks[${index}].interestRate`);
          }}
          variant="standard"
        />
      </FormControl>
      <ErrorMessage
        name={`tracks[${index}].interestRate`}
        component="div"
        className="absolute text-red"
      />
    </div>
  );
};
export default InterstRate;